import { put, call, takeLatest } from "redux-saga/effects";
import * as Auth from "store/actions/auth";
import User from "lib/user";
import EmployeeApi from "lib/employee"; 

export default function* watcherSaga() {
    yield takeLatest(Auth.ACTION_LOGIN, loginSaga);
    yield takeLatest(Auth.ACTION_EMPLOYEE_LOGIN, employeeLoginSaga);
}

function* loginSaga(action) {
    try {
        const { username, password } = action;
        const userData = yield call(User.login, username, password);
        yield put({ type: Auth.ACTION_LOGIN_SUCCESS, user: userData });
    } catch (error) {
        yield put({ type: Auth.ACTION_LOGIN_ERROR, error: error.message });
    }
}

function* employeeLoginSaga(action) {
    try {
        const { username, password } = action;
        const response = yield call(EmployeeApi.loginEmployee, username, password);
        
        if (response && response.api_token) {
            localStorage.setItem("employee_token", response.api_token);
            localStorage.setItem("employee_id", response.id); 
        }

        yield put({ 
            type: Auth.ACTION_EMPLOYEE_LOGIN_SUCCESS, 
            user: response
        });
    } catch (error) {
        yield put({ 
            type: Auth.ACTION_EMPLOYEE_LOGIN_ERROR, 
            error: error.message 
        });
    }
}